// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyAwRsQa8nAq16vFwAQ6oO4S9lzp_-4988c',
    authDomain: 'innovate.avio.aero',
    databaseURL: 'https://innovate.avio.aero',
    projectId: 'avio-innovate',
    storageBucket: 'avio-innovate.appspot.com',
    messagingSenderId: '795597431422',
  },
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
